import { render, staticRenderFns } from "./FormatFixedPhraseSelector.vue?vue&type=template&id=5639e94e&scoped=true&"
import script from "./FormatFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatFixedPhraseSelector.vue?vue&type=style&index=0&id=5639e94e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5639e94e",
  null
  
)

export default component.exports